import { useState } from 'react';
import { useBoolean } from './use-boolean';

export function useImagePreview() {
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const open = useBoolean(false);

  const handleImageClick = (url: string) => {
    setImageUrl(url);
    open.onTrue();
  };

  const handleClose = () => {
    open.onFalse();
    setImageUrl(null);
  };

  return {
    imageUrl,
    isOpen: open.value,
    handleImageClick,
    handleClose,
  };
}
